import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export let previousPage = ''
let newPage = ''
export const usePreviousPage = () => {
    const location = useLocation()

    useEffect(() => {
        previousPage = newPage
        newPage = location.pathname
    }, [location.pathname])
}
